import { Box, TableCell, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { Icon } from './Icon';
import { osirisTokens } from '@/theme/tokens';

interface SortableHeaderProps {
  field: string;
  children: React.ReactNode;
  align?: 'left' | 'right' | 'center';
  sortBy: string;
  sortOrder?: 'asc' | 'desc';
  onSort: (field: string) => void;
  sx?: SxProps<Theme>;
}

export function SortableHeader({
  field,
  children,
  align = 'left',
  sortBy,
  sortOrder = 'asc',
  onSort,
  sx,
}: SortableHeaderProps) {
  const isActive = sortBy === field;

  return (
    <TableCell
      onClick={() => onSort(field)}
      className={`sortable-header sortable-${field}${isActive ? ' is-active' : ''}`}
      sx={{
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: align,
        height: 24,
        py: 0,
        px: '12px',
        borderBottom: 'none',
        bgcolor: 'transparent',
        '&:hover': {
          bgcolor: osirisTokens.alpha.dark100,
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:
            align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
          gap: 0.5,
        }}
      >
        <Typography
          component="span"
          sx={{
            fontFamily: osirisTokens.fonts.body,
            fontSize: 11,
            fontWeight: 400,
            letterSpacing: '0.22px',
            textTransform: 'uppercase',
            color: isActive ? osirisTokens.text.primary : osirisTokens.text.tertiary,
          }}
        >
          {children}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: osirisTokens.text.tertiary,
            lineHeight: 0,
          }}
        >
          {/* One icon family for every state — the MUI filled triangles read as a
              different icon set than the inactive chevrons (Figma To Do 28458:16926). */}
          {/* Unsorted: Figma icon/sort (28235:60551), 16px */}
          <Icon
            name={!isActive ? 'sort' : sortOrder === 'asc' ? 'arrow-up-S' : 'arrow-down-S'}
            size={isActive ? 14 : 16}
          />
        </Box>
      </Box>
    </TableCell>
  );
}
